import { TAB_SET } from '../constants/tabs';
export const isCollaborationSidebarTabType = tab => {
  return TAB_SET.has(tab);
};